import {
  Box,
  Button,
  ButtonProps,
  Flex,
  Icon,
  IconButton,
} from "@chakra-ui/react";
import { Dispatch, SetStateAction } from "react";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from "../../../../../shared/views/icons";

interface Props {
  pageSize: number;
  pageIndex: number;
  setPageIndex: Dispatch<SetStateAction<number>>;
  nItems: number;
}
export const PageControls: React.FC<Props> = ({
  pageSize,
  nItems,
  pageIndex,
  setPageIndex,
}) => {
  const lastPageIndex = Math.floor((nItems - 1) / pageSize);
  const isFirstPage = pageIndex === 0;
  const isLastPage = lastPageIndex === pageIndex;
  const pageNumber = pageIndex + 1;

  return (
    <Box>
      <Flex alignItems={"center"}>
        <IconButton
          {...buttonProps}
          disabled={isFirstPage}
          onClick={() => {
            setPageIndex((i) => i - 1);
          }}
        >
          <Icon as={ChevronLeftIcon} />
        </IconButton>

        <Flex minW="40px" justifyContent={"center"}>
          {!isFirstPage && (
            <Button
              {...buttonProps}
              px={1}
              disabled={isFirstPage}
              onClick={() => {
                setPageIndex(0);
              }}
            >
              1 ...
            </Button>
          )}
        </Flex>

        <Box
          bgColor="primary.500"
          color="white"
          width="24px"
          textAlign="center"
          fontWeight="semibold"
          borderRadius={20}
        >
          {pageNumber}
        </Box>

        <Flex minW="40px" justifyContent={"center"}>
          {!isLastPage && (
            <Button
              {...buttonProps}
              px={1}
              disabled={isLastPage}
              onClick={() => {
                setPageIndex(lastPageIndex);
              }}
            >
              ... {lastPageIndex + 1}
            </Button>
          )}
        </Flex>

        <IconButton
          {...buttonProps}
          disabled={isLastPage}
          onClick={() => {
            setPageIndex((i) => i + 1);
          }}
        >
          <Icon as={ChevronRightIcon} />
        </IconButton>
      </Flex>
    </Box>
  );
};

const buttonProps: ButtonProps = {
  colorPalette: "primary",
  size: "sm",
  fontSize: "sm",
  variant: "ghost",
};
